import React from 'react'
import tasksReducer from './tasksReducer'
import State from '@customTypes/state'

interface InitialState {
    state: State
    dispatch?: any
}

const tasksContext = React.createContext<InitialState>({
    state: {
        tasks: []
    },
    dispatch: tasksReducer
})
export default tasksContext
